<template>
  <div>
    <header>
      <div class="header">
        <div class="main">
          <div class="title">離反予報</div>
        </div>

        <div gl-tooltip="ヘルプ" gl-tooltip-direction="down">
          <gl-button icon-button @click="moveToHelp">
            <gl-icon-help />
          </gl-button>
        </div>
        <div gl-tooltip="ログアウト" gl-tooltip-direction="down">
          <gl-button icon-button @click="logout">
            <md-icon>
              <font-awesome-icon icon="sign-out-alt" />
            </md-icon>
          </gl-button>
        </div>
      </div>
    </header>
    <main>
      <md-dialog
        class="loading-dialog"
        :md-active.sync="loading"
        :md-close-on-esc="false"
        :md-click-outside-to-close="false"
      >
        <md-dialog-content>
          <spinner />
          <p>
            {{ loadingMessage }}
          </p>
        </md-dialog-content>
      </md-dialog>
      <slot></slot>
    </main>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'
import { SET_ACCOUNT } from '@/const/mutation-types'

export default {
  components: {
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
    },
    loadingMessage: {
      type: String,
    },
  },
  methods: {
    moveToHelp() {
      window.open(`${process.env.VUE_APP_HELP_SITE_URL_BASE}frog.html`)
    },
    async logout() {
      await window.ssoClient.signout()
      this.$store.commit(SET_ACCOUNT, {})
      location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
$header-height: 72px;

header {
  align-items: center;
  display: flex;
  background-color: var(--bg-color-primary);
  border-bottom: 2px solid var(--color-border);
  flex-direction: columns;
  height: $header-height;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  justify-content: flex-end;
}
.header {
  align-items: center;
  display: flex;
  background-color: var(--bg-color-primary);
  left: 0;
  margin-left: var(--spacing-large);
  margin-right: var(--spacing-large);
  width: 100%;

  .main {
    flex: 1;
    // 左右のコンポーネントの幅が固定されている訳ではないので、この中を
    // 中央寄せにしてしまうと画面の中央にならないのでtext-align:centerしていない
  }

  .title {
    font-size: var(--font-size-large);
    margin-left: var(--spacing-large);
  }
}
main {
  background: var(--bg-color-primary);
  padding-top: $header-height;
  position: relative;
  width: 100%;
  z-index: 1;
}
.loading-dialog {
  flex-direction: column;
  align-items: center;
}
</style>
